import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbInputDatepickerConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CompanyBasic } from '../../models';
import { AbstractCRUD, BannerNotificationsService, SpinnerService } from '../../../xform-compat';
import { Subscription } from 'rxjs';
import { CRMStatusLabels } from '../../models/crm/CRMStatus';
import { CrmService } from '../../../core/data-services/crm.service';
import { EventsHubService } from '../../../core/events-hub.service';
import { CrmStatusService } from '../../../core/data-services/crm-status.service';
import { BaseCRMItem, CRMItem } from '../../models/crm/CRMItem.model';
import { CourtshipTypeEnum } from '../../enums/courtship-type.enum';
import { CRMCompanyStorm } from '../../models/crm/CRMCompanyStorm';
import { Router } from '@angular/router';
import { CrmItemType } from '../../enums/crm-item-type.enum';
import { StructCapCRMItem } from '../../models/crm/struct-cap/StructCapCRMItem.model';
import { StructCapCrmService } from '../../../core/data-services/struct-cap-crm.service';
import { STRUCT_CAP_URL_ROOT } from '../../../modules/crm/struct-cap-crm/struct-cap-crm-parent/struct-cap-crm-parent.component';
import { CrmIntegrationService } from '../../../core/services/crm-integration.service';


@Component({
    selector: 'rms-add-crm',
    templateUrl: './add-crm.component.html',
    styleUrls: ['./add-crm.component.scss'],
    providers: [NgbInputDatepickerConfig],
    standalone: false
})
export class AddCrmComponent implements OnInit, OnDestroy {

  public crmItemType: CrmItemType = CrmItemType.STANDARD;
  public inputCrmItem: CRMItem | StructCapCRMItem;
  public editMode = false;
  public inputCompanyId: number;
  public newRecordWarning = false;
  public shouldNotify = true;
  @ViewChild('addCrmModal', { static: true }) modal: ElementRef;
  private modalReference: NgbModalRef;

  private modalSubscription: Subscription;

  public companyList: Array<CompanyBasic> = new Array<CompanyBasic>();
  public readonly statusLabels = CRMStatusLabels;
  public readonly courtship = CourtshipTypeEnum;
  public readonly storm = CRMCompanyStorm;
  public readonly itemTypes = CrmItemType;

  constructor(
    private crmService: CrmService,
    private structCapCrmService: StructCapCrmService,
    public crmStatusService: CrmStatusService,
    private eventsHubService: EventsHubService,
    private modalService: NgbModal,
    private spinnerService: SpinnerService,
    private bannerNotificationService: BannerNotificationsService,
    private router: Router,
    private crmIntegrationService: CrmIntegrationService,
    ) {
  }

  ngOnInit() {
    this.modalSubscription = this.eventsHubService.onAddCrmModalOpens$.subscribe((data = {}) => {
      const {
        inputCrmItem = null,
        editMode = false,
        inputCompanyId = null,
        newRecordWarning = false,
        crmItemType = CrmItemType.STANDARD,
        onSave = (savedCrm, route) => this.router.navigate([`/${route}/item/${savedCrm.id}`]),
        onCancel = () => {},
        onErr = () => {}
      } = data;

      this.inputCrmItem = inputCrmItem;
      this.editMode = editMode;
      this.inputCompanyId = inputCompanyId;
      this.newRecordWarning = newRecordWarning;
      this.crmItemType = crmItemType;

      this.modalReference = this.modalService.open(this.modal, { size: 'lg', centered: true,
        beforeDismiss: () => {
          if (!this.crmIntegrationService.isClean()) {
            return window.confirm('Discard your changes?');
          }
          return true;
        }
      });
      this.modalReference.result.then(result => {
        if (result) {
          this.spinnerService.start();
          let service: AbstractCRUD<BaseCRMItem>;
          let route: string;
          switch (this.crmItemType) {
            case CrmItemType.STANDARD:
              service = this.crmService;
              route = 'sonar';
              break;
            case CrmItemType.STRUCT_CAP:
              service = this.structCapCrmService;
              route = `sonar/${STRUCT_CAP_URL_ROOT}`;
              break;
            default:
              throw new Error('Invalid Sonar item type: ' + this.crmItemType);
          }
          const obs = this.editMode ? service.updateRecord(result) : service.createRecord(result);
          obs.subscribe((resp) => {
            this.spinnerService.stop();
            onSave(resp, route);
            this.bannerNotificationService.success(`SONAR saved`);
          }, err => {
            this.bannerNotificationService.error(err);
            onErr(err);
            this.spinnerService.stop();
          });
        }
      }).catch(error => {
        onCancel(error);
      }).finally(() => this.reset());
    });
  }

  ngOnDestroy () {
    this.modalSubscription.unsubscribe();
  }

  public reset() {
    this.inputCrmItem = null;
    this.editMode = false;
    this.inputCompanyId = null;
    this.newRecordWarning = false;
  }

  public submit(item: any) {
    this.modalReference.close({...item, shouldNotify: this.shouldNotify});
  }

  public close() {
    this.modalReference.close(null);
  }

  public archiveRecord(item: BaseCRMItem) {
    this.modalReference.dismiss({...item, archive: true });
  }
}
